import axios from "axios";

const BASE_URL = "https://academy-nyctophile.herokuapp.com/api";
const getCources = async () => {
  const response = await axios.get(`${BASE_URL}/term/getall`);
  return response.data.result;
};
const getArticle = async () => {
  const response = await axios.get(`${BASE_URL}/news/topArticles`);
  return response.data.result;
};
const LoginUser = async (obj) => {
  try {
    const resulte = await axios.post("https://academy-nyctophile.herokuapp.com/api/auth/login", obj);
    return resulte;
  } catch (error) {
    console.log(error);
  }
};
const RegisterUser = async (obj) => {
  try {
    const data = await axios.post("https://academy-nyctophile.herokuapp.com/api/auth/Register", obj);
    return data;
  } catch (error) {
    console.log(error);
  }
};
export { getCources, getArticle, LoginUser,RegisterUser };
